import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@dotcom/crown-ui';
import { FontDrawerFooterProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';

export const FontDrawerFooter = ({ onCancel, onSubmit }: FontDrawerFooterProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Button
        testId="font-drawer-footer-cancel"
        variant={'link'}
        onClick={onCancel}
        className={styles['secondary-button']}
      >
        {t('fontDrawer.cancel')}
      </Button>
      <Button
        testId="font-drawer-footer-apply"
        variant={'primary'}
        onClick={onSubmit}
        className={styles['primary-button']}
      >
        {t('fontDrawer.apply')}
      </Button>
    </>
  );
};
